import { render } from "./Info.vue?vue&type=template&id=3b2afa3f&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=3b2afa3f&lang=css"
import "./Info.vue?vue&type=style&index=1&id=3b2afa3f&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Info.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2afa3f"]])

export default __exports__